import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function TrendingBar() {
  const titles = articles.slice(0, 8);

  return (
    <section
      aria-label="实时爆料滚动"
      className="mx-auto mt-5 w-full max-w-[1280px] px-4 md:px-6"
    >
      <div className="flex items-center gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-100 py-3">
        <span className="ml-4 flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600">
          <i className="ri-radar-line text-base" aria-hidden="true"></i>
          实时爆料
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee gap-8">
            {[...titles, ...titles].map((item, index) => (
              <Link
                key={`${item.id}-${index}`}
                to={`/article/${item.id}`}
                className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600"
              >
                {item.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}